import '../../style/index.css';
import './index.css'; // style dependencies

import '../../empty/style/css';
import '../../checkbox/style/css';
import '../../button/style/css';
import '../../input/style/css';
import '../../menu/style/css';
import '../../dropdown/style/css';
import '../../pagination/style/css';